import React from "react";

export const BetaBranchContext = React.createContext(undefined);
